import {
  STORE_SELECTED_EDI_RECORDS,
  CLEAR_SELECTED_EDI_RECORDS,
} from "../actionTypes";
export const selectedEdiRecords = (selectedRow) => {
  return {
    type: STORE_SELECTED_EDI_RECORDS,
    payload: selectedRow,
  };
};

export const clearSelectedEdiRecords = () => {
  return {
    type: CLEAR_SELECTED_EDI_RECORDS,
  };
};
